import { useFindSettings } from './settings'

export function useSiteFeatures() {
  const { data: settings } = useFindSettings()

  const isMidstreamProcess = settings?.featureToggles.find(
    (ft) => ft.key === 'sap:midstreamProcess',
  )?.isEnabled

  function getFeatureValues(featureKey: string): string[] | undefined {
    const values = settings?.featureToggles.find(
      (ft) => ft.key === featureKey,
    )?.featureSettingsValues

    const result = values?.map((o) => o.value).filter((v): v is string => v !== undefined)
    return result
  }

  function taskHasCriticality(jobAbcIndicator: string | undefined) {
    const featureValues =
      getFeatureValues('sap:midstreamProcess')?.some(
        (abcInd) => abcInd?.trim() === jobAbcIndicator,
      ) ?? false

    return featureValues
  }

  return { isMidstreamProcess, getFeatureValues, taskHasCriticality }
}
